export const addComma = (acc: string, cur: string) => {
  if (acc.length === 0) {
    return (acc += cur);
  }

  return (acc = `${acc}, ${cur}`);
};
